(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1481],{

/***/ 5273:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29238);
/* harmony import */ var isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_slick__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46066);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9473);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(55760);
/* harmony import */ var _components_Default_Teaser_v1_Action__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(92533);
/* harmony import */ var _store_features_genericSlice__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(88751);
/* harmony import */ var _components_Default_PromoBanner_v1_index_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(38326);
/* harmony import */ var _components_Default_PromoBanner_v1_index_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_components_Default_PromoBanner_v1_index_module_scss__WEBPACK_IMPORTED_MODULE_8__);









const PromoBanner = (param)=>{
    let { data ={} , properties ={}  } = param;
    var ref, ref1, ref2, ref3;
    const promoBannerSettings = {
        dots: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        swipeToSlide: true,
        swipe: true,
        arrows: true,
        infinite: true,
        centerMode: false
    };
    const { eventPageType  } = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_7__.selectGenericState);
    const dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useDispatch */ .I0)();
    const setPromoModal = (data)=>{
        dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_7__.showPromoModal)(data));
        (0,_utils_helper__WEBPACK_IMPORTED_MODULE_5__.preventBodyScroll)(true);
    };
    const [bannerIndex, setBannerIndex] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0);
    const getComponentMessage = (message, index)=>{
        if (message && index > -1) {
            const obj = JSON.parse(message);
            obj.componentInfo.componentMessage = "".concat(obj.componentInfo.componentMessage).concat(index + 1);
            return JSON.stringify(obj);
        }
    };
    const afterChangeHandler = (currentIndex)=>{
        setBannerIndex(currentIndex);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_components_Default_PromoBanner_v1_index_module_scss__WEBPACK_IMPORTED_MODULE_8___default().promoBannerWrapper),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "carousel-slick carousel ".concat(data === null || data === void 0 ? void 0 : (ref = data.carouselComponentProperties) === null || ref === void 0 ? void 0 : ref.appliedCssClassNames),
            role: "group",
            "aria-label": data["carouselComponentProperties"]["accessibilityLabel"] || undefined,
            "aria-roledescription": "carousel",
            "data-gbh-data-layer": '{"clickInternalLinks":"true","internalLinkPosition":"'.concat(eventPageType, ":").concat((properties === null || properties === void 0 ? void 0 : properties.componentPosition) ? properties.componentPosition : "carousel", '","internalLinkZoneName":"').concat(data === null || data === void 0 ? void 0 : data.pageName.toLowerCase(), ":").concat((properties === null || properties === void 0 ? void 0 : properties.componentZone) ? properties.componentZone : "carousel", '","internalLinkURL":"n/a","internalLinkName":"carousel:rm","eventName":"').concat(data === null || data === void 0 ? void 0 : (ref1 = data.pageName) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase(), '","internalLinkType":"').concat((properties === null || properties === void 0 ? void 0 : properties.componentLinkType) ? properties.componentLinkType : "navigation", '","eventType":"carousel","eventAction":"').concat(data === null || data === void 0 ? void 0 : (ref2 = data.pageName) === null || ref2 === void 0 ? void 0 : ref2.toLowerCase(), '"}'),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "cmp-carousel cmp-carousel-slick ",
                role: "group",
                "aria-label": data["carouselComponentProperties"]["accessibilityLabel"] || undefined,
                "aria-roledescription": "carousel",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_slick__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    ...promoBannerSettings,
                    className: "cmp-carousel-slick__content single-slider",
                    afterChange: afterChangeHandler,
                    children: data["carouselComponentProperties"][":itemsOrder"] && ((ref3 = data["carouselComponentProperties"][":itemsOrder"]) === null || ref3 === void 0 ? void 0 : ref3.map((key, index, arr)=>{
                        var ref;
                        const item = data["carouselComponentProperties"][":items"][key];
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "promo-banner",
                                style: {
                                    visibility: "visible"
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "cmp-promo__description",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            dangerouslySetInnerHTML: {
                                                __html: isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_2___default().sanitize(item === null || item === void 0 ? void 0 : item.description)
                                            }
                                        }),
                                        (item === null || item === void 0 ? void 0 : item.actionsEnabled) && (item === null || item === void 0 ? void 0 : (ref = item.actionItems) === null || ref === void 0 ? void 0 : ref.map((action, index)=>{
                                            var ref;
                                            return action.enablePopup ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                onClick: ()=>setPromoModal({
                                                        show: true,
                                                        modalContent: {
                                                            banner: item,
                                                            item: action,
                                                            count: index
                                                        }
                                                    }),
                                                "data-toggle": "modal",
                                                "data-target": "#".concat(item === null || item === void 0 ? void 0 : item.promoId, "-").concat(index),
                                                className: "cmp-promo__action-link btn promo-banner-fragment",
                                                rel: "".concat(action.linkRef ? "noreferrer" : ""),
                                                "data-gbh-component": getComponentMessage(item === null || item === void 0 ? void 0 : item.componentInfos, bannerIndex),
                                                "data-gbh-data-layer": '{"clickInternalLinks":"true","internalLinkPosition":"'.concat(item === null || item === void 0 ? void 0 : (ref = item.pageType) === null || ref === void 0 ? void 0 : ref.toLowerCase(), ":").concat((properties === null || properties === void 0 ? void 0 : properties.componentPosition) ? properties.componentPosition : "promo banner", '","internalLinkZoneName":"').concat(item === null || item === void 0 ? void 0 : item.pageType.toLowerCase(), ":").concat((properties === null || properties === void 0 ? void 0 : properties.componentZone) ? properties.componentZone : "global header", '","internalLinkURL":"n/a","internalLinkName":"').concat(action === null || action === void 0 ? void 0 : action.text, '","eventName":"').concat(action === null || action === void 0 ? void 0 : action.text.toLowerCase(), '","internalLinkType":"').concat((properties === null || properties === void 0 ? void 0 : properties.componentLinkType) ? properties.componentLinkType : "navigation", '","eventType":"promo banner","eventAction":"').concat(action === null || action === void 0 ? void 0 : action.text.toLowerCase(), '"}'),
                                                "data-gbh-clickable": true,
                                                children: action === null || action === void 0 ? void 0 : action.text
                                            }, "#".concat(item === null || item === void 0 ? void 0 : item.promoId, "-").concat(index)) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Default_Teaser_v1_Action__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                                item: item,
                                                ...action,
                                                link: (action === null || action === void 0 ? void 0 : action.link) || (action === null || action === void 0 ? void 0 : action.ctaLink),
                                                newTab: action === null || action === void 0 ? void 0 : action.isNewTab,
                                                bannerIndex: bannerIndex
                                            }, "promo-banner-action-".concat(bannerIndex + 1, "-").concat((0,_utils_helper__WEBPACK_IMPORTED_MODULE_5__.getRandom)()));
                                        }))
                                    ]
                                })
                            })
                        }, (item === null || item === void 0 ? void 0 : item.id) ? item === null || item === void 0 ? void 0 : item.id : "cmp-promo-banner-".concat(index, "-").concat((0,_utils_helper__WEBPACK_IMPORTED_MODULE_5__.getRandom)()));
                    }))
                })
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (PromoBanner);


/***/ }),

/***/ 92533:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9473);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41609);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _constants_config__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(19514);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(55760);
/* harmony import */ var _store_features_authSlice__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(24899);
/* harmony import */ var _store_features_genericSlice__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(88751);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(96301);
/* harmony import */ var _components_Default_Teaser_v1_analytics__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(81873);











const Action = (props)=>{
    const { primaryCTA ="" , secondaryCTA ="" , playVideoCTA ="" , videoTitle ="" , mainTitle ="" , link ="" , text ="" , newTab ="" , urlRef ="" , id ="" , pageType ="" , linkAll ="" , componentPosition =null , eventName =null , eventAction =null , dataLayerLinkType ="".concat(pageType, ":").concat(mainTitle) , productCategory =null , productCollectionsName =null , productRoom =null , propertiesPageType ="" , playVideoCTAcb =()=>"" , index =0 , activeIndex =0 , setActive =()=>"" , item , bannerIndex =-1 , generalConfigData ={}  } = props;
    const { scroll , findAPro , installationServices  } = _constants__WEBPACK_IMPORTED_MODULE_9__.DEFAULT_SCROLL;
    const shortLink = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_6__.getShortenedUrlwithGeneral)(link, generalConfigData);
    const [general, setGeneral] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(generalConfigData);
    const dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useDispatch */ .I0)();
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    const { isAuth  } = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(_store_features_authSlice__WEBPACK_IMPORTED_MODULE_7__/* .selectAuthState */ ._9);
    const { pageType: datalayerPageType  } = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_8__.selectGenericState);
    const [actionLink, setActionLink] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(shortLink);
    const [target, setTarget] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [loginRegisterCallback, setLoginRegisterCallback] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (loginRegisterCallback && isAuth && router.pathname.includes(_constants__WEBPACK_IMPORTED_MODULE_9__.MY_ACCOUNT_PATH)) {
            handleOnLinkClick(loginRegisterCallback);
        }
    }, [
        loginRegisterCallback,
        isAuth
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (lodash_isEmpty__WEBPACK_IMPORTED_MODULE_3___default()(generalConfigData)) {
            (0,_constants_config__WEBPACK_IMPORTED_MODULE_5__/* .getConfig */ .i)().then(async (config)=>{
                setGeneral(config === null || config === void 0 ? void 0 : config.general);
            });
        }
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (lodash_isEmpty__WEBPACK_IMPORTED_MODULE_3___default()(generalConfigData)) {
            if (!lodash_isEmpty__WEBPACK_IMPORTED_MODULE_3___default()(link) && !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_3___default()(general)) {
                const actLink = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_6__.getShortenedUrlwithGeneral)(link, general);
                setActionLink(actLink);
            }
        }
    }, [
        link,
        general
    ]);
    const handleLogin = (e)=>{
        if (router.pathname.includes(_constants__WEBPACK_IMPORTED_MODULE_9__.MY_ACCOUNT_PATH)) {
            e.preventDefault();
            e.stopPropagation();
            window.loginRegisterCallback = ()=>{
                setLoginRegisterCallback(e);
                if (actionLink) router.push(actionLink);
            };
            dispatch((0,_store_features_authSlice__WEBPACK_IMPORTED_MODULE_7__/* .setAuthModalVisibility */ .LY)({
                show: true
            }));
        } else {
            handleOnLinkClick();
        }
    };
    const handleOnLinkClick = (event)=>{
        return propertiesPageType == "modalWindow" && playVideoCTA ? playVideoCTAcb(event) : undefined;
    };
    const handleOnClick = (event)=>{
        var ref;
        var ref1;
        const actionLink = (ref1 = event === null || event === void 0 ? void 0 : (ref = event.target) === null || ref === void 0 ? void 0 : ref.getAttribute("href")) !== null && ref1 !== void 0 ? ref1 : "";
        if (actionLink === null || actionLink === void 0 ? void 0 : actionLink.startsWith("#KPN")) {
            event.preventDefault();
            const link1 = actionLink.split("::");
            const id = link1[0];
            const url = link1[1];
            if (link1) {
                dispatch((0,_store_features_authSlice__WEBPACK_IMPORTED_MODULE_7__/* .setHideCustomerSignupCTA */ .n$)(true));
                if (id === null || id === void 0 ? void 0 : id.includes("signIn")) {
                    window.KPNSignIn = true;
                    (0,_utils_helper__WEBPACK_IMPORTED_MODULE_6__.isAuthenticated)(url, 0, true);
                } else if (id === null || id === void 0 ? void 0 : id.includes("createAccount")) {
                    window.KPNSignIn = false;
                    (0,_utils_helper__WEBPACK_IMPORTED_MODULE_6__.isAuthenticated)(url, 1, true);
                } else {
                    (0,_utils_helper__WEBPACK_IMPORTED_MODULE_6__.isAuthenticated)(url);
                }
            }
        }
        const currentIndex = Number(event.target.getAttribute("data-index")) || 0;
        const componentInfo = event.target.getAttribute("data-gbh-component");
        setActive(currentIndex);
        if (event.target.getAttribute("href").startsWith("#") && Object.values(_constants__WEBPACK_IMPORTED_MODULE_9__.MORE_OPTIONS).includes(event.target.text)) {
            exploreMoreScroll(event);
        } else if (router.pathname.includes(_constants__WEBPACK_IMPORTED_MODULE_9__.MY_ACCOUNT_PATH) && !isAuth) {
            handleLogin(event);
        } else {
            handleOnLinkClick(event);
        }
        (0,_components_Default_Teaser_v1_analytics__WEBPACK_IMPORTED_MODULE_10__/* .addTeaserActionAnalytics */ .tP)({
            newTab,
            pageType,
            componentPosition,
            videoTitle,
            link,
            text,
            eventName,
            dataLayerLinkType,
            eventAction,
            productCategory,
            productCollectionsName,
            productRoom,
            datalayerPageType,
            mainTitle,
            componentInfo
        });
    };
    // global explore more scroll
    const exploreMoreScroll = (e)=>{
        e.preventDefault();
        const hash = e.target.hash;
        if (hash === "") return;
        const element = document.querySelector(hash);
        if (!element) return;
        const offsetTop = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_6__.getOffsetTop)(element) - (hash === _constants__WEBPACK_IMPORTED_MODULE_9__.FIND_A_PRO_HASH ? findAPro : hash === _constants__WEBPACK_IMPORTED_MODULE_9__.INSTALLATION_SERVICES_HASH ? installationServices : scroll);
        window.scrollTo({
            top: offsetTop,
            behavior: "smooth"
        });
    };
    // Added to fix eslint error Disallow target="_blank" attribute without rel="noreferrer" (react/jsx-no-target-blank)
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (newTab === false || newTab === "false") {
            setTarget("_self");
        } else {
            setTarget("_blank");
        }
    }, [
        newTab
    ]);
    const getComponentMessage = function() {
        let message = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
        if (message && bannerIndex > -1) {
            const obj = JSON.parse(message);
            obj.componentInfo.componentMessage = "".concat(obj.componentInfo.componentMessage).concat(bannerIndex + 1);
            return JSON.stringify(obj);
        }
    };
    if (!linkAll) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
            className: "cmp-teaser__action-link ".concat((0,_utils_helper__WEBPACK_IMPORTED_MODULE_6__.convertStringToBoolean)(primaryCTA) ? "gbh-primary-button " : "").concat((0,_utils_helper__WEBPACK_IMPORTED_MODULE_6__.convertStringToBoolean)(secondaryCTA) ? "gbh-secondary-button " : "").concat(propertiesPageType === "modalWindow" && playVideoCTA ? "video-play-button " : "", " ").concat(index === activeIndex ? "active" : ""),
            role: "button",
            "aria-describedby": id,
            href: actionLink,
            "aria-label": text,
            target: target,
            rel: urlRef ? "noreferrer" : "",
            onClick: handleOnClick,
            "data-index": index,
            "data-gbh-component": getComponentMessage(item === null || item === void 0 ? void 0 : item.componentInfos),
            children: text
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "cmp-teaser__action-link ".concat((0,_utils_helper__WEBPACK_IMPORTED_MODULE_6__.convertStringToBoolean)(primaryCTA) ? "gbh-primary-button " : "").concat((0,_utils_helper__WEBPACK_IMPORTED_MODULE_6__.convertStringToBoolean)(secondaryCTA) ? "gbh-secondary-button " : "").concat(pageType == "modalWindow" && playVideoCTA ? "video-play-button " : ""),
        role: "button",
        "aria-describedby": id || "",
        rel: urlRef ? "noreferrer" : "",
        "aria-label": text,
        children: text
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Action);


/***/ }),

/***/ 81873:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FS": function() { return /* binding */ getDownloadEventInfo; },
/* harmony export */   "Rj": function() { return /* binding */ getTitleEventInfo; },
/* harmony export */   "ht": function() { return /* binding */ addDatalayerShare; },
/* harmony export */   "tP": function() { return /* binding */ addTeaserActionAnalytics; },
/* harmony export */   "wQ": function() { return /* binding */ getEventInfo; }
/* harmony export */ });
/* harmony import */ var _constants_regex__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(49139);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55760);


const getEventInfo = function() {
    let pageType = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", componentPosition = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", mainTitle = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", eventLabel = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "", dataLayerLinkType = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "", eventType = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : "", zone = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : "", parseJson = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : false;
    const zoneName = zone ? zone === null || zone === void 0 ? void 0 : zone.replace(_constants_regex__WEBPACK_IMPORTED_MODULE_1__/* .SPECIAL_CHAR_REGEX */ .FU, " ") : "zone";
    let internalLinkType = "";
    if (eventLabel === "print") {
        internalLinkType = "".concat(pageType.toLowerCase(), ":").concat(mainTitle.toLowerCase(), ":print");
    } else {
        internalLinkType = "".concat(dataLayerLinkType);
    }
    const internalLinkZoneName = zone ? "".concat(pageType.toLowerCase(), ":").concat(zoneName) : "teaser";
    const eventInfo = {
        clickInternalLinks: "true",
        internalLinkPosition: "".concat(pageType.toLowerCase(), ":").concat(componentPosition ? componentPosition : "teaser"),
        internalLinkZoneName,
        internalLinkURL: "n/a",
        internalLinkName: "".concat(eventLabel),
        eventName: "".concat(pageType.toLowerCase(), ":").concat(eventLabel === "print" ? eventLabel : "".concat(zoneName, ":share")),
        internalLinkType: internalLinkType,
        eventType: eventType,
        eventAction: "".concat(pageType.toLowerCase(), ":").concat(eventLabel === "print" ? eventLabel : "".concat(zoneName, ":share"))
    };
    if (parseJson) {
        return eventInfo;
    }
    return JSON.stringify(eventInfo);
};
const addDatalayerShare = function() {
    let data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "{}", isPdp = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const eventInfo = JSON.parse(data);
    const dataLayerObj = {
        event: "cmp:click",
        page,
        eventInfo
    };
    if (isPdp) {
        const { productInfo  } = page;
        dataLayerObj["productInfo"] = productInfo;
    }
    window.adobeDataLayer.push(dataLayerObj);
};
const getDownloadEventInfo = function() {
    let downLoadLink = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", pageType = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", componentPosition = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", mainTitle = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "", dataLayerLinkType = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "";
    let eventInfo = {};
    if (downLoadLink) {
        eventInfo = {
            clickInternalLinks: "true",
            internalLinkPosition: "".concat(pageType.toLowerCase(), ":").concat(componentPosition ? componentPosition : "teaser"),
            internalLinkZoneName: "teaser",
            internalLinkURL: "".concat(downLoadLink),
            internalLinkName: "download",
            eventName: "".concat(pageType.toLowerCase(), ":download"),
            internalLinkType: "".concat(pageType.toLowerCase(), ":").concat(mainTitle.toLowerCase(), ":download"),
            eventType: "teaser",
            eventAction: "".concat(pageType.toLowerCase(), ":download")
        };
    } else {
        eventInfo = {
            clickInternalLinks: "true",
            internalLinkPosition: "".concat(pageType.toLowerCase(), ":").concat(componentPosition || "teaser"),
            internalLinkZoneName: "teaser",
            internalLinkURL: "n/a",
            internalLinkName: "download",
            eventName: "".concat(pageType.toLowerCase(), ":download"),
            internalLinkType: "".concat(dataLayerLinkType),
            eventType: "teaser",
            eventAction: "".concat(pageType.toLowerCase(), ":download")
        };
    }
    return JSON.stringify(eventInfo);
};
const getTitleEventInfo = function() {
    let linkNewTab = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false, componentPosition = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", linkURL = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", mainTitle = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "", pageType = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "", componentLinkType = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : "", title = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : "";
    return '{"clickInternalLinks":"'.concat(linkNewTab || mainTitle.toLowerCase().includes("kohler canada") ? "false" : "true", '","internalLinkPosition":"').concat(pageType === null || pageType === void 0 ? void 0 : pageType.toLowerCase(), ":").concat(componentPosition || "teaser", '","internalLinkZoneName":"teaser","internalLinkURL":"').concat(linkURL || (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__.getLinkFromHref)(title), '","internalLinkName":"').concat(mainTitle.toLowerCase(), '","eventName":"').concat(pageType.toLowerCase(), ":zone:").concat(mainTitle.toLowerCase(), '","internalLinkType":"').concat(pageType, ":").concat(componentLinkType ? componentLinkType : mainTitle.toLowerCase(), '","eventType":"teaser","eventAction":"').concat(pageType.toLowerCase(), ":zone:").concat(mainTitle.toLowerCase(), '"}');
};
const addTeaserActionAnalytics = (param)=>{
    let { newTab , pageType , componentPosition , videoTitle , link , text , eventName: eventNameDatalayer , dataLayerLinkType , eventAction: eventActionDataLayer , productCategory , productCollectionsName , productRoom , datalayerPageType , mainTitle , componentInfo =""  } = param;
    let eventAction = "".concat(pageType === null || pageType === void 0 ? void 0 : pageType.toLowerCase(), ":").concat((eventActionDataLayer === null || eventActionDataLayer === void 0 ? void 0 : eventActionDataLayer.toLowerCase()) || "zone", ":").concat(text === null || text === void 0 ? void 0 : text.toLowerCase());
    let eventName = "".concat(pageType === null || pageType === void 0 ? void 0 : pageType.toLowerCase(), ":").concat((eventNameDatalayer === null || eventNameDatalayer === void 0 ? void 0 : eventNameDatalayer.toLowerCase()) || "zone", ":").concat(text === null || text === void 0 ? void 0 : text.toLowerCase());
    let internalLinkZoneName = "".concat(videoTitle || pageType.toLowerCase() === "plp" || pageType.toLowerCase() === "press-kit" ? "".concat(pageType.toLowerCase(), ":").concat(pageType.toLowerCase() === "press-kit" ? "press-release" : "hero banner") : "teaser");
    let internalLinkPosition = "".concat(pageType === null || pageType === void 0 ? void 0 : pageType.toLowerCase(), ":").concat(componentPosition || "teaser");
    let internalLinkType = "".concat(videoTitle ? "".concat(pageType.toLowerCase(), ":").concat(videoTitle) : dataLayerLinkType);
    if (dataLayerLinkType.includes("social impact")) {
        eventName = "".concat(dataLayerLinkType.substring(0, dataLayerLinkType.lastIndexOf(":")), ":").concat(text === null || text === void 0 ? void 0 : text.toLowerCase());
        eventAction = "".concat(dataLayerLinkType.substring(0, dataLayerLinkType.lastIndexOf(":")), ":").concat(text === null || text === void 0 ? void 0 : text.toLowerCase());
        internalLinkZoneName = "".concat(dataLayerLinkType.substring(0, dataLayerLinkType.lastIndexOf(":")));
    }
    let eventType = "teaser";
    if (datalayerPageType.includes("locations")) {
        pageType = "locations:kohler stores";
        eventName = "".concat(pageType === null || pageType === void 0 ? void 0 : pageType.toLowerCase(), ":").concat(text === null || text === void 0 ? void 0 : text.toLowerCase());
        eventAction = "".concat(pageType === null || pageType === void 0 ? void 0 : pageType.toLowerCase(), ":").concat(text === null || text === void 0 ? void 0 : text.toLowerCase());
        internalLinkZoneName = pageType === null || pageType === void 0 ? void 0 : pageType.toLowerCase();
        internalLinkPosition = "".concat(pageType === null || pageType === void 0 ? void 0 : pageType.toLowerCase(), ":teaser");
        internalLinkType = "".concat(pageType.toLowerCase(), ":").concat(mainTitle);
    }
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    if ((text === "Get Started" || text === "Apply Now") && eventActionDataLayer === null) {
        var ref;
        const NewDatalayerPageType = datalayerPageType === "services" ? page === null || page === void 0 ? void 0 : (ref = page.category) === null || ref === void 0 ? void 0 : ref.subCategoryID : datalayerPageType;
        eventAction = text.toLowerCase();
        eventName = text.toLowerCase();
        eventType = "promo banner";
        internalLinkPosition = "".concat(NewDatalayerPageType === null || NewDatalayerPageType === void 0 ? void 0 : NewDatalayerPageType.toLowerCase(), ":promo banner");
        internalLinkType = "navigation";
        internalLinkZoneName = "".concat(NewDatalayerPageType === null || NewDatalayerPageType === void 0 ? void 0 : NewDatalayerPageType.toLowerCase(), ":promo details");
    }
    const eventInfo = {
        clickInternalLinks: (link === null || link === void 0 ? void 0 : link.startsWith("/")) || (link === null || link === void 0 ? void 0 : link.startsWith("#")) || (link === null || link === void 0 ? void 0 : link.includes(window.location.hostname)) ? "true" : "false",
        internalLinkPosition,
        internalLinkZoneName,
        internalLinkURL: link ? "".concat(link.indexOf("http") === -1 ? window.location.origin : "").concat((0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__.removeAndCleanLink)(link)) : "n/a",
        internalLinkName: "".concat(!text ? "explore more arrow" : text.toLowerCase()),
        eventName,
        internalLinkType,
        eventType,
        eventAction,
        eventMsg: "n/a",
        eventStatus: "n/a"
    };
    const customDataLayer = {
        componentInfo: JSON.parse(componentInfo),
        productInfo: {
            productCategory: productCategory || "n/a",
            productCollectionsName: productCollectionsName || "n/a",
            productRoom: productRoom || "n/a"
        }
    };
    (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__.pushAnalyticsObjToDataLayer)(eventInfo, "cmp:click", {}, customDataLayer);
};


/***/ }),

/***/ 38326:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"promoBannerWrapper":"v1_promoBannerWrapper__J4Pwk"};

/***/ }),

/***/ 93967:
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = '';

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (arg) {
				classes = appendClass(classes, parseValue(arg));
			}
		}

		return classes;
	}

	function parseValue (arg) {
		if (typeof arg === 'string' || typeof arg === 'number') {
			return arg;
		}

		if (typeof arg !== 'object') {
			return '';
		}

		if (Array.isArray(arg)) {
			return classNames.apply(null, arg);
		}

		if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
			return arg.toString();
		}

		var classes = '';

		for (var key in arg) {
			if (hasOwn.call(arg, key) && arg[key]) {
				classes = appendClass(classes, key);
			}
		}

		return classes;
	}

	function appendClass (value, newClass) {
		if (!newClass) {
			return value;
		}
	
		if (value) {
			return value + ' ' + newClass;
		}
	
		return value + newClass;
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ })

}]);